/**
 * Lets you scroll to the top of an element
 * Takes Navbar height into account
 * You can add an offset to the scroll position
 */
const scrollToElement = (
  element,
  isMobile = false,
  offset = 0,
  behavior = 'smooth',
) => {
  const navbarHeight = isMobile ? 64 : 140;

  // we scroll to the top of the element
  const scrollPosition = element.offsetTop - (navbarHeight + offset);

  if (element) {
    window.scrollTo({ left: 0, top: scrollPosition, behavior });
  }
};

export default scrollToElement;
